import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axiosInstance";

// Base API URL
const API_BASE_URL = "/api/v1/auth/";
const API_BASE_URL_USER = "/api/v1/user/";

// Get all users
export const fetchUsers = createAsyncThunk("user/fetchUsers", async (queryParams = {}) => {
  console.log("user is called");
  const res = await axios.get(`${API_BASE_URL_USER}getAllUsers`,{
    params: queryParams,
  });
  console.log("::fetch user res", res);
  return res.data;
});

// Create a user
export const createUser = createAsyncThunk(
  "user/createUser",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${API_BASE_URL}/signup`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data.data;
    } catch (error) {
      // Properly extract backend message and return it
      const message =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      return rejectWithValue(message);
    }
  }
);


export const getUserById = createAsyncThunk(
  "user/getUserById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE_URL_USER}getUserId/${id}`);
      return res.data; 
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      return rejectWithValue(message);
    }
  }
);

// Update a user
export const updateUser = createAsyncThunk(
  "user/updateUser",
  async ({ formData, id }, { rejectWithValue }) => {
    try {
  
      const res = await axios.patch(
        `${API_BASE_URL_USER}updateMe?id=${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Something went wrong while updating user.";
      return rejectWithValue(message);
    }
  }
);

// Delete a user
export const deleteUser = createAsyncThunk("user/deleteUser", async (id) => {
  await axios.delete(`${API_BASE_URL_USER}deleteMe`, {
    params: { id },
  });
  return id;
});

const userSlice = createSlice({
  name: "user",
  initialState: {
    users: [],
    data: {},
    loading: false,
    error: null,
  },
  reducers: {
    resetUserState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Users
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      // .addCase(fetchUsers.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.users = action?.payload?.data?.users;
      //   state.data = action.payload;
      //   state.success=false;
      // })

      .addCase(fetchUsers.fulfilled, (state, action) => {
  state.loading = false;
  state.users = action?.payload?.data?.users || []; // ✅ fix here
  state.pagination = action?.payload?.pagination || {};
  state.success = false;
})

      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })   
      // Create User
       .addCase(createUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createUser.fulfilled, (state) => {
        state.loading = false;
        state.success=true
      })
      .addCase(createUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to create user.";
      })

      // Update User
      .addCase(updateUser.fulfilled, (state, action) => {
        const index = state.users.findIndex(
          (u) => u._id === action.payload._id
        );
        if (index !== -1) state.users[index] = action.payload;
        state.loading = false;
        state.success = true;
      })
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })
      // Delete User
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.users = state.users.filter((u) => u._id !== action.payload);
      })
      .addCase(getUserById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.loading = false;
        state.success=false;
        state.selectedUser = action.payload;
    
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUserState } = userSlice.actions;
export default userSlice.reducer;
